import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";

// Fix para o warning "Unable to preventDefault inside passive event listener"
// que ocorre no ApexCharts durante zoom/pan
((): void => {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const originalAddEventListener = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function (
    this: EventTarget,
    type: string,
    listener: EventListenerOrEventListenerObject | null,
    options?: boolean | AddEventListenerOptions,
  ): void {
    const modifiedOptions =
      typeof options === "boolean"
        ? options
        : ({ ...options, passive: false } as AddEventListenerOptions);

    if (
      ["touchstart", "touchmove", "wheel", "mousewheel"].includes(type) &&
      this instanceof Element &&
      this.closest(".apexcharts-canvas")
    ) {
      originalAddEventListener.call(this, type, listener, modifiedOptions);
      return;
    }

    originalAddEventListener.call(this, type, listener, options);
  };
})();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
